// src/store/auth.store.js
import { create } from "zustand";

export const useAuthStore = create((set) => ({
  token: null,
  user: null,
  initialized: false, 

  // login ahora recibe token y user
  login: (token, user) => {
    sessionStorage.setItem("token", token);
    sessionStorage.setItem("user", JSON.stringify(user));
    set({ token, user });
  },

  // logout limpia todo
  logout: () => {
    sessionStorage.clear();
    set({ token: null, user: null });
  },

  // inicializa estado desde sessionStorage al cargar la app
  init: () => {
    const token = sessionStorage.getItem("token");
    const user = sessionStorage.getItem("user");
    set({ token: token || null, user: user ? JSON.parse(user) : null, initialized: true });
  },
}));



// Recuperar token directamente desde sessionStorage
export function getToken() {
  return sessionStorage.getItem("token");
}

// Recuperar usuario
export function getUser() {
  const user = sessionStorage.getItem("user");
  return user ? JSON.parse(user) : null;
}
